export default {
    dependencies: ['$element', 'trackingservice'],
    callable(formEle, trackingservice) {
        const validationTypes = {
            required(value) {
                return typeof value === 'string' && value.trim() !== '';
            },
            email(value) {
                const pattern = /.+@.+/;
                return pattern.test(value);
            },
        };

        function select(...args) {
            return formEle.querySelector(
                `[data-contact-message-${args.join('-')}]`
            );
        }

        function getValidationRules() {
            // new object for each validation as hasError and errorMessage state gets added
            return [
                {
                    input: 'textarea',
                    type: ['required', 'Melding er tom'],
                },
                {
                    input: 'email',
                    type: [
                        ['required', 'E-post er tom'],
                        ['email', 'Ugyldig e-post'],
                    ],
                },
                {
                    input: 'from',
                    type: ['required', 'Hilsen er tom'],
                },
            ].filter(data => {
                const inputEl = select(data.input);
                if (!inputEl) {
                    return false;
                }
                data.element = select(data.input);
                data.errorElement = select(data.input, 'error');
                return data;
            });
        }

        function runValidation(resultItemHandler) {
            function setErrorsOnSpec(spec) {
                function typeProcessor(typeSpec) {
                    // yield after first error
                    if (spec.hasError) {
                        return;
                    }

                    if (Array.isArray(typeSpec) && Array.isArray(typeSpec[0])) {
                        return typeSpec.forEach(typeProcessor);
                    }

                    const type = typeSpec[0];
                    const fn = validationTypes[type];
                    if (!fn) {
                        throw new Error(
                            `No validation for type [${type}] implemented`
                        );
                    }

                    if (spec.element && fn(spec.element.value) !== true) {
                        spec.errorMessage = typeSpec[1];
                        spec.hasError = true;
                    }
                }
                return typeProcessor(spec.type);
            }

            const data = getValidationRules();
            data.forEach(setErrorsOnSpec);
            if (resultItemHandler) {
                data.forEach(resultItemHandler);
            }
            return data;
        }

        function submitHandler(submitEvent) {
            let hasError = false;
            runValidation(resultEntry => {
                const ele = resultEntry.errorElement;
                if (resultEntry.hasError) {
                    hasError = true;
                    submitEvent.preventDefault();
                    // show error
                    ele.textContent = resultEntry.errorMessage;
                    ele.classList.remove('hidden');
                } else {
                    // clean and hide error
                    ele.textContent = '';
                    ele.classList.add('hidden');
                }
            });
            if (!hasError) {
                preventMultipleSubmits();
                trackSend();
            }
        }

        function preventMultipleSubmits() {
            [
                ...formEle.querySelectorAll('button[type=submit]'),
            ].forEach(button => {
                button.disabled = true;
                button.classList.add('inprogress');
            });
        }

        function trackSend() {
            const finnkode = formEle.getAttribute('data-finnkode');
            trackingservice.trackLaterObj({
                analyticsName: 'contact.send-message.sent',
                eventFlags: 'success',
                kpi: 'effect',
                context: {
                    finnkode,
                },
                ecType: 'AD',
                ecCategory: 'LOG_GENERAL_MAIL',
                pulse: {
                    type: 'Send',
                    object: {
                        type: 'Message',
                        id: 0,
                        name: 'Send Message',
                        inReplyTo: {
                            type: 'ClassifiedAd',
                            id: finnkode,
                            name: document.title,
                        },
                    },
                },
            });
        }

        function init() {
            formEle.addEventListener('submit', submitHandler);

            const messageInput = select('textarea');
            if (!messageInput) {
                return;
            }
        }

        return init();
    },
};



// WEBPACK FOOTER //
// ./controllers/validateContactForm.js